import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../../dataManagement/uiDb/UiDb";
import MyMessagesThunk from "../../../../../services/thunks/MyMessagesThunk";

/**
 * Hook to check if the current user already has an active offer
 * (active conversation) for the given product.
 * Fetches messages once if they haven't been loaded yet.
 */
export const useHasActiveOffer = (productId: string): boolean => {
  const dispatch = useDispatch();
  const didFetch = useRef(false);

  const messagesData = useSelector(
    (state: RootState) => state.messages?.data
  ) as any;

  // Fetch messages once if not already loaded
  useEffect(() => {
    if (!messagesData && !didFetch.current) {
      didFetch.current = true;
      dispatch(MyMessagesThunk.fetchMyMessages() as any);
    }
  }, [messagesData, dispatch]);

  const activeConversations = messagesData?.activeConversations ?? [];

  return activeConversations.some(
    (conv: any) => conv.productId === productId
  );
};
